module.exports = __webpack_public_path__ + "static/szenario3-c701681fb1d08ce38530c3bbd77e2a74.png";